import { render, staticRenderFns } from "./o-stepper.vue?vue&type=template&id=1529a2f4&scoped=true&"
import script from "./o-stepper.vue?vue&type=script&lang=js&"
export * from "./o-stepper.vue?vue&type=script&lang=js&"
import style0 from "./o-stepper.vue?vue&type=style&index=0&id=1529a2f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1529a2f4",
  null
  
)

export default component.exports